import { SideBarBadge } from "src/components/badges"
import RenewalsProvider from "../interfaces/RenewalsProvider"
import { useRenewals } from "../interfaces/Renwals"
import { extractDueDateStatus } from "./dueDates"
import IpRightsProvider from "../interfaces/IpRightsProvider"

export function RenewalBadge({smallMenu}) {
  return (
    <IpRightsProvider>
      <RenewalsProvider states={['Open']}>
        <ActualRenewalsBadge {...{ smallMenu }} />
      </RenewalsProvider>
    </IpRightsProvider>
  )
}

function ActualRenewalsBadge({ smallMenu }) {
  const { renewals } = useRenewals()
  const today = new Date().toISOString().slice(0, 10)

  const needsWarning = renewals.some(r => {
    if (!r.isAutoPay) {
      const status = extractDueDateStatus(r, today)
      return status === 'critical' || status === 'manual-instruction'
    } else {
      return false
    }
  })
  const hasOpen = renewals.some(r => r.state === 'Open')

  const severity = needsWarning ? 'warning' : hasOpen ? 'info' : 'no-show'

  // console.log({hasOpen, needsWarning, renewals})

  return <SideBarBadge {...{ smallMenu, severity }} />
}